(function () {
  function initAddonVariantSelectors(root = document) {
    root.querySelectorAll('[data-addon-item]').forEach((item) => {
      if (item.dataset.addonVariantInitialized === 'true') return;

      const checkbox = item.querySelector('[data-addon-checkbox]');
      const variantJson = item.querySelector('[data-addon-variants]');
      const originalSelector = item.querySelector('[data-addon-variant-selector]');
      const priceDisplay = item.querySelector('[data-addon-price-display]');

      if (!checkbox || !variantJson) return;

      let variants = [];

      try {
        variants = JSON.parse(variantJson.textContent);
      } catch (error) {
        console.error('3DMARK add-on variants JSON error:', error);
        return;
      }

      const packQuantity =
        parseInt(item.dataset.addonPackQuantity || '1', 10) || 1;

      const originalOptionSelectors = originalSelector
        ? Array.from(originalSelector.querySelectorAll('[data-addon-option]'))
        : [];

      const optionDefinitions = originalOptionSelectors.map((select) => {
        return {
          label:
            select.closest('.addon-variant-option')
              ?.querySelector('.addon-variant-option__label')
              ?.textContent?.trim() || '',
          options: Array.from(select.options).map((option) => ({
            value: option.value,
            text: option.textContent.trim()
          }))
        };
      });

      /**
       * 如果是 pack > 1：
       * 把原本一組 selector 轉成多件 selector。
       */
      if (packQuantity > 1 && originalSelector && optionDefinitions.length > 0) {
        const packWrapper = document.createElement('div');
        packWrapper.className = 'addon-pack-selector';
        packWrapper.setAttribute('data-addon-pack-selector', '');

        /* 依商品 option 數量加入 class */
        packWrapper.classList.add(
        `addon-pack-selector--options-${optionDefinitions.length}`
        );

        /* 預設收起，勾選加購後才顯示 */
        packWrapper.hidden = !checkbox.checked;

        for (let unitIndex = 0; unitIndex < packQuantity; unitIndex += 1) {
          const unit = document.createElement('div');

          unit.className = 'addon-pack-unit';
          unit.dataset.addonPackUnit = String(unitIndex + 1);

          const title = document.createElement('div');

          title.className = 'addon-pack-unit__title';
          title.textContent = `第 ${unitIndex + 1} 件`;

          unit.appendChild(title);

          const optionsRow = document.createElement('div');
          optionsRow.className = 'addon-pack-unit__options';

          optionDefinitions.forEach((definition, optionIndex) => {
            const wrapper = document.createElement('div');

            wrapper.className = 'addon-variant-option';

            const label = document.createElement('label');

            label.className = 'addon-variant-option__label';
            label.textContent = definition.label;

            const select = document.createElement('select');

            select.className = 'addon-variant-option__select';
            select.dataset.addonPackOption = '';
            select.dataset.packUnitIndex = String(unitIndex);
            select.dataset.optionIndex = String(optionIndex);

            definition.options.forEach((optionData) => {
              const option = document.createElement('option');

              option.value = optionData.value;
              option.textContent = optionData.text;

              select.appendChild(option);
            });

            wrapper.appendChild(label);
            wrapper.appendChild(select);
            optionsRow.appendChild(wrapper);
          });

          unit.appendChild(optionsRow);
          packWrapper.appendChild(unit);
        }

        originalSelector.replaceWith(packWrapper);
      }

      function getUnitSelectors() {
        if (packQuantity <= 1) {
          return [
            Array.from(item.querySelectorAll('[data-addon-option]'))
          ];
        }

        return Array.from(
          item.querySelectorAll('[data-addon-pack-unit]')
        ).map((unit) => {
          return Array.from(
            unit.querySelectorAll('[data-addon-pack-option]')
          );
        });
      }

      function findVariantBySelectors(selectors) {
        if (!selectors || selectors.length === 0) {
          return variants.find((variant) => variant.available) || variants[0];
        }

        const selectedOptions = selectors.map((select) => select.value);

        return variants.find((variant) => {
          return variant.options.every((value, index) => {
            return value === selectedOptions[index];
          });
        });
      }

      function updateAddonVariantData() {
        const unitSelectors = getUnitSelectors();
        const selectedVariants = [];
        let allAvailable = true;

        unitSelectors.forEach((selectors) => {
          const variant = findVariantBySelectors(selectors);

          if (!variant || !variant.available) {
            allAvailable = false;
          }

          if (variant) {
            selectedVariants.push(variant);
          }
        });

        /**
         * 單件模式：
         * 保留原本 dataset.variantId 行為。
         */
        if (packQuantity <= 1) {
          const variant = selectedVariants[0];

          if (!variant) {
            checkbox.checked = false;
            checkbox.disabled = true;
            checkbox.dataset.variantId = '';
            checkbox.dataset.addonPrice = '0';

            item.classList.add('addon-item--unavailable');
            return;
          }

          checkbox.dataset.variantId = String(variant.id);
          checkbox.dataset.addonPrice = String(variant.price);

          if (priceDisplay) {
            priceDisplay.textContent = variant.priceFormatted;
          }
        }

        /**
         * Pack 模式：
         * 把每件所選 variant 儲存在 JSON dataset。
         */
        if (packQuantity > 1) {
          const packVariants = selectedVariants.map((variant) => ({
            id: variant.id,
            price: variant.price,
            available: variant.available,
            options: variant.options
          }));

          checkbox.dataset.addonPackVariants =
            JSON.stringify(packVariants);

          checkbox.dataset.addonPackQuantity =
            String(packQuantity);

          const totalPrice = selectedVariants.reduce((total, variant) => {
            return total + Number(variant.price || 0);
          }, 0);

          checkbox.dataset.addonPrice = String(totalPrice);

          if (priceDisplay) {
            const moneyFormat =
              window.theme?.moneyFormat ||
              window.theme?.settings?.moneyFormat;

            try {
              if (window.Shopify?.formatMoney) {
                priceDisplay.textContent =
                  Shopify.formatMoney(totalPrice, moneyFormat);
              }
            } catch (error) {
              //
            }
          }
        }

        if (allAvailable && selectedVariants.length === packQuantity) {
          checkbox.disabled = false;
          item.classList.remove('addon-item--unavailable');
        } else {
          checkbox.checked = false;
          checkbox.disabled = true;
          item.classList.add('addon-item--unavailable');
        }

        checkbox.dispatchEvent(
          new CustomEvent('addon:variant-change', {
            bubbles: true,
            detail: {
              variants: selectedVariants,
              packQuantity
            }
          })
        );

        checkbox.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }

/**
 * 勾選加購品後才展開選項
 */
function updateSelectorVisibility() {
  const selector =
    item.querySelector('[data-addon-pack-selector]') ||
    item.querySelector('[data-addon-variant-selector]');

  if (!selector) return;

  selector.hidden = !checkbox.checked;

  item.classList.toggle(
    'addon-item--selected',
    checkbox.checked
  );
}

checkbox.addEventListener('change', updateSelectorVisibility);

updateSelectorVisibility();

      item
        .querySelectorAll(
          '[data-addon-option], [data-addon-pack-option]'
        )
        .forEach((select) => {
          select.addEventListener(
            'change',
            updateAddonVariantData
          );
        });

      item.dataset.addonVariantInitialized = 'true';

      updateAddonVariantData();
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAddonVariantSelectors();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initAddonVariantSelectors(event.target);
  });
})();